import { UtilService } from '../../../../shared/services/util/util.service';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { causeList } from './causes-object-v3';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-causes-list-v3',
  templateUrl: './causes-list-v3.component.html',
  styleUrls: ['./causes-list-v3.component.scss']
})
export class CausesListComponentV3 implements OnInit {
  causes: { outer: boolean, class: string, link: string, title: string, desc: string, params?: any, imgSrc: string }[] = causeList;
  @Input('defaultImg') defaultImg: string;
  lazyLoadImage;
  isMobile: any;
  show = false;
  moreBtn = 'View More';
  
  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    initialSlide: 1,
    navigation: true,
    keyboard: true,
    scrollbar: false,
    loop: false,
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      768: {
        slidesPerView: 1.6,
        centeredSlides: false,
        allowTouchMove: true,
        navigation: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
    }
  };

  constructor(
    private utilService: UtilService,
    private actRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }
}
